import { ReactElement } from "react";
import { CalendarHighlightDateOnlyRange } from "client/Components";
import styles from "./SidebarCalendar.module.less";
import { TimeZone } from "client/DateAndTime/timezones";
import { DateOnly } from "client/DateAndTime/dateOnly";
import { CalendarDateSelector } from "../CalendarDateSelector";

export type SidebarCalendarProps = {
	date: DateOnly | undefined;
	calculateHighlightRangeForDate?(date: DateOnly): CalendarHighlightDateOnlyRange;
	onChange(date: DateOnly): void;
	timezone: TimeZone;
};

export const SidebarCalendar = (props: SidebarCalendarProps): ReactElement => {
	const {
		date,
		calculateHighlightRangeForDate,
		onChange,
		timezone
	} = props;

	return (
		<div className={styles.root}>
			<CalendarDateSelector
				date={date}
				calculateHighlightRangeForDate={calculateHighlightRangeForDate}
				onChange={onChange}
				timezone={timezone}
				trackingId="sidebar-calendar"
			/>
		</div>
	);
};
SidebarCalendar.displayName = "SidebarCalendar";
